<!--
 - Author : wanghongling.
 - Date   : 2019/5/27.
 - File   : dashboard.仪表盘组件
 -->

<template>
  <div class="dashboardBg" :id="id" :style="{width: dashboardObj.width||'130px', height:dashboardObj.height||'130px'}"></div>
</template>

<script>
export default {
  name: 'dashboard',
  data () {
    return {
      myDashboard: null
    }
  },
  props: {
    id: {
      type: String,
      default: 'test'
    },
    dashboardObj: {
      width: '130px',
      height: '130px'
    }
  },
  watch: {
    dashboardObj: {
      handler () {
        this.$nextTick(() => {
          // window.removeEventListener('resize', this.resizeEvent)
          this.makeDashboard()
        })
      },
      deep: true
    }
  },
  destroyed () {
    this.$echarts.dispose(this.myDashboard)
    // window.removeEventListener('resize', this.resizeEvent)
    this.myDashboard = null
  },
  mounted () {
    this.init()
  },
  methods: {
    /**
     * 初始化echart
     * @author: whl
     * @createDate: 2019/8/9
     * @return {Object}
     */
    init () {
      let that = this
      let myDashboard = that.$echarts.init(document.getElementById(that.id))
      that.myDashboard = myDashboard
      that.makeDashboard()
    },
    /**
     * echart赋值
     * @author: whl
     * @createDate: 2019/8/9
     * @return {Object}
     */
    makeDashboard () {
      let center1 = ['50%', '50%']
      let radius1 = ['100%', '20%', '80%']
      let option = {
        tooltip: {
          show: false
        },
        series: [
          {
          type: 'gauge',
          center: center1, // 默认全局居中
          radius: radius1[0],
          splitNumber: 10, // 刻度数量
          min: 0,
          max: 15000,
          startAngle: 200,
          endAngle: -20,

          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              shadowBlur: 0,
              color: [
                [1, 'rgba(5,172,147,0.9)']
              ]
            }
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: 'rgba(5,172,147,0.2)',
              width: 1
            },
            length: 6,
            splitNumber: 1
          },
          splitLine: {
            show: true,
            length: 10,
            lineStyle: {
              color: 'rgba(5,172,147,0.1)'
            }
          },
          axisLabel: {
            show: false,
            distance: 8,
            textStyle: {
              color: '#fff',
              fontSize: '12'
            }
          },
          pointer: { // 仪表盘指针
            show: 0
          },
          detail: {
            //   值的样式
            show: false, // 是否显示仪表盘数字
            formatter: '{value}',
            textStyle: {
              color: '#fff',
              fontSize: '20',
              fontFamily: '微软雅黑'
            }
          },
          data: [{
            name: '',
            show: false, // 是否显示仪表盘单位
            value: this.dashboardObj.value // 仪表盘的值
          }]
        }, {
          name: '剩余电量',
          type: 'gauge',
          startAngle: 200,
          endAngle: -20,
          radius: radius1[2],
          center: center1, // 默认全局居中
          min: 0,
          max: 1500,
          axisLine: {
            show: true,
            lineStyle: {
              width: 8, // 彩色圈的大小
              shadowBlur: 0,
              color: [
                [0.2, '#12e2f1'],
                [0.4, '#82bb4f'],
                [0.6, '#d9bc42'],
                [0.8, '#e28d1b'],
                [1, '#db3d38']
              ]
            }
          },
          axisTick: {
            show: false

          },
          splitLine: {
            show: false,
            length: 15
          },
          axisLabel: {
            show: false
          },
          pointer: {
            show: true,
            width: 4
          },
          detail: {
            //   电文字的样式
            show: false,
            formatter: this.dashboardObj.detail || '电',
            textStyle: {
              color: '#5affe6',
              fontSize: '14',
              fontFamily: '微软雅黑'
            },
            offsetCenter: [0, '85%']
          },
          itemStyle: {
            normal: {
              color: '#e2dfe0'
            }
          },
          data: [{
            name: '',
            value: this.dashboardObj.value || '10'
          }]
        }
        ]
      }
      this.myDashboard.setOption(option)
      // window.addEventListener('resize', this.resizeEvent)
    },
    /**
     * echart图表适应
     * @author: whl
     * @createDate: 2019/8/9
     * @return {Object}
     */
    resizeEvent() {
      this.myDashboard.resize() // 使图表适应
    }
  }
}
</script>

<style>
  .dashboardBg{
    background: url("../../assets/images/index/dashboardBg.png") center;
    background-size: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/echarts/dashboard.vue